import { AfterViewInit, Component, ComponentFactoryResolver, ComponentRef, ElementRef, Injector, Input, OnDestroy, OnInit, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { ContentElement, RendererType, RichTextOptions } from '@urbannex/storethemes';
import { ColorPickerPopoverComponent } from '../color-picker-popover/color-picker-popover.component';
import { BorderPresetPopoverComponent } from '../border-preset-popover/border-preset-popover.component';
import { Subject, Subscription } from 'rxjs';
import { CssServicesService } from '../../../services/css-services.service';
import { take, takeUntil } from 'rxjs/operators';
import { PaddingPresetPopoverComponent } from '../padding-preset-popover/padding-preset-popover.component';
import { SliderPopoverComponent } from '../slider-popover/slider-popover.component';
import { Page, Section, SectionData } from '../../../editor-container/editor-model';
import { SectionEditorStoreService } from './section-editor-store.service';
import { NbAdjustment, NbDialogRef, NbIconLibraries, NbMenuBag, NbMenuComponent, NbMenuItem, NbMenuService, NbOverlayRef, NbOverlayService, NbPosition, NbPositionBuilderService } from '@nebular/theme';
import exportFromJSON from 'export-from-json';
import { FontSizePopoverComponent } from '../font-size-popover/font-size-popover.component';
import { FontFamilyPopoverComponent } from '../font-family-popover/font-family-popover.component';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import { EditorInputField } from '../../../editor-container/editor-model';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { EditState } from '../../../model';
import { sectionDialogMenuItems, sectionEditorIcons } from './section-dialog-menu-items';
import { FontWeightPopoverComponent } from '../font-weight-popover/font-weight-popover.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { SectionOptionsService } from '../../sections-editor/section-options/section-options.service';
import { TextEditorPopverComponent } from '../text-editor-popver/text-editor-popver.component';
import { OverlayRef } from '@angular/cdk/overlay';
import { VisibilityPopoverComponent } from '../visibility-popover/visibility-popover.component';

@Component({
  selector: 'kve-section-editor-dialog',
  templateUrl: './section-editor-dialog.component.html',
  styleUrls: ['./section-editor-dialog.component.scss']
})
/**
 * SectionEditorDialogComponent is used to edit section properties like title, background, padding, margin, etc.
 * It uses SectionEditorStoreService to manage section data and communicate changes.
 * 
 * It also uses CssServicesService to get available colors and current page background.
 * It uses NbMenuService to handle menu item clicks and show appropriate popovers for editing properties.
 * The component is designed to be used within a dialog and provides save and close functionality.
 * The component also supports exporting section data as JSON and taking snapshots of the section.
 * The component implements OnInit, OnDestroy, and AfterViewInit lifecycle hooks to manage initialization, cleanup, and view-related logic.
 * 
 * Inputs:
 * - section: The section to be edited.
 * - title: The title content element of the section.
 * - dialogWidth: The width of the dialog.
 * Outputs:
 * - onSave: Emits the updated section when saved.
 * - onClose: Emits when the dialog is closed without saving.
 * Menu creaction and handling is done using Nebular's NbMenuService.
 * 
 * SectionOptionServices:
 * - Used to initialize and manage section options and menu items.
 * - Provides a centralized way to handle section-related settings and options.
 * - Menu items are dynamically updated based on the section data and options.
 */
export class SectionEditorDialogComponent implements OnInit,OnDestroy,AfterViewInit {
  @Input() section:Section;
  @Input() title:ContentElement;
  @Input() dialogWidth:number;
  sectionData:SectionData;
  rendererType:RendererType;

  titleText:string;

  textPop: any = TextEditorPopverComponent;

  colorPop: any = ColorPickerPopoverComponent;

  borderPop:any = BorderPresetPopoverComponent;

  paddingPop:any = PaddingPresetPopoverComponent;

  sliderPop:any = SliderPopoverComponent;

  fontSizePop:any = FontSizePopoverComponent;

  fontFamPop:any = FontFamilyPopoverComponent;

  fontWeight:any = FontWeightPopoverComponent;

  visibilityPop:any = VisibilityPopoverComponent;

  textColor:string;
  bgColors$:Subscription;
  pmColors$:Subscription;
  bgBasic:string[]=[]
  bgPrimary:string[]=[]
  bgAlt:string[]=[]
  fillColors:string[];
  primaryColors:string[]=[];

  currentPageBg:string;
  background:string;
  paddingTop:string;

  selectedHeaderClass;
  selectedAlignment;
  selectedFontFam;
  selectedContent:ContentElement;
  options:RichTextOptions
  /**
   * rendererType?:string;
       heading?:string;
       content?:any;
       invert?:boolean;
       headerSizeClass?:"default" | "medium" | "small"; 
       rowCells?:RowCell[];
   */
  richTextOptionFields:EditorInputField[] = [
    {
      name: "heading",
      title: 'Content Name',
      type: 'text',
      controlType: ''
    },
    {
      name: "headerSizeClass",
      title: 'Hear font size',
      type: 'text',
      controlType: ''
    }
  ]

  headerClasses = [
    {name:"Header 1",class:"h1"},
    {name:"Header 2",class:"h2"},
    {name:"Header 3",class:"h3"},
    {name:"Header 4",class:"h4"},
    {name:"Header 5",class:"h5"},
    {name:"Header 6",class:"h6"},
  ]
  paddingClasses = [

  ]

  alignments = [
    {name:"Left",class:"justify-left"},
    {name:"Center",class:"justify-center"},
    {name:"Right",class:"justify-right"}
  ]

  fontFams = [
    {
      name:"Arial",
      value:"Arial, sans-serif"
    },
    {
      name:"Courier New",
      value:"Courier New, monospace"
    },
    {
      name:"Georgia",
      value:"Georgia, serif"
    },
    {
      name:"Lato",
      value:"Lato, sans-serif"
    },
    {
      name:"Lobster",
      value:"Lobster, sans-serif"
    },
    {
      name:"Merriweather",
      value:"Merriweather, sans-serif"
    },
    {
      name:"Montserrat",
      value:"Montserrat, sans-serif"
    },
    {
      name:"Open Sans",
      value:"Open Sans, sans-serif"
    },
    {
      name:"Oswald",
      value:"Oswald, sans-serif"
    },
    {
      name:"PT Sans",
      value:"PT Sans, sans-serif"
    },
    {
      name:"Playfair Display",
      value:"Playfair Display,serif"
    },
    {
      name:"Raleway",
      value:"Raleway, sans-serif"
    },
    {
      name:"Roboto",
      value:"Robotto, sans-serif"
    },
    {
      name:"Roboto Condensed",
      value:"Roboto Condensed, sans-serif"
    },
    {
      name:"Roboto Slab",
      value:"Roboto Slab, sans-serif"
    },
    {
      name:"Source Sans 3",
      value:"Source Sans 3, sans-serif"
    },
    {
      name:"Ubuntu",
      value:"Ubuntu, sans-serif"
    }
  ]

  headers = [
    {name:"Header 6",value:"h6"},
    {name:"Header 5",value:"h5"},
    {name:"Header 4",value:"h4"},
    {name:"Header 3",value:"h3"},
    {name:"Header 2",value:"h2"},
    {name:"Header 1",value:"h1"},
  ]

  color$:Subscription;
  marginBottom:number;
  sectionData$:Subscription;

  sectionDialogMenuItems:NbMenuItem[] = sectionDialogMenuItems;
  
  @ViewChild('titleHost', {read: ElementRef}) titleHost: ElementRef<HTMLElement>;
  @ViewChild(NbMenuComponent, { read: ElementRef }) menuElementRef!: ElementRef;
  private currentOverlayRef: OverlayRef | null = null;
  private backdropSubscription: Subscription | null = null;
  private destroy$ = new Subject<void>()
  
  constructor(
    protected ref: NbDialogRef<SectionEditorDialogComponent>,private cssService:CssServicesService,
    private sectionEditorStoreService:SectionEditorStoreService,
     private previewEditStoreService:PreviewEditStoreService,
     private iconLibraries: NbIconLibraries,
     private menuService:NbMenuService,
     private overlayService: NbOverlayService,
     private viewContainerRef: ViewContainerRef,
     private componentFactoryResolver: ComponentFactoryResolver,
     private positionBuilder: NbPositionBuilderService,
     private injector: Injector,
    private communicator:IframeCommunicationService,
    private sectionOptionsService: SectionOptionsService) { 
      this.menuService.onItemClick()
      .pipe(takeUntil(this.destroy$))
      .subscribe((menuBag) => {
        let menuTag = menuBag.tag;
        if(menuTag && menuTag === "sectionEditorMenu"){
          console.log(menuBag)
          
         //this.showPopover(menuBag);
        }
      })
    }
  
  

  ngOnInit(): void {
    this.iconLibraries.registerSvgPack('section-menu-icons',sectionEditorIcons);
    console.log(this.section);
    console.log(this.dialogWidth);
    if(this.section){
      this.sectionData = this.section.sectionData;
      this.sectionOptionsService.initializeSectionOptions(this.sectionData);
      this.rendererType = this.section.rendererType;
      this.sectionEditorStoreService.setState({sectionId:this.section.sectionId,sectionData:this.section.sectionData});
      // Subscribe to menu items
      this.sectionOptionsService.menuItems$
        .pipe(takeUntil(this.destroy$))
        .subscribe(items => {
          this.sectionDialogMenuItems = items;
          console.log(this.sectionData,this.sectionDialogMenuItems);
        });
      if(this.sectionData.title){
        this.title = this.sectionData.title;
      }else{
        this.sectionData.title = {
          elId:'1',
          text:"No Title",
          name:"Title",
          classes:["h6","justify-center"],
          fontFamily:"Open Sans,sans serif"
        }
        this.title = this.sectionData.title;
      }
      if(this.title.fontFamily){
        this.fontFams.forEach(fontFam => {
          if(fontFam.value = this.title.fontFamily){
            this.selectedFontFam = fontFam;
          }
        })      
      }else{
        this.title.fontFamily = "Open Sans,sans serif";
        this.selectedFontFam = this.title.fontFamily;
      }
      if(this.title.classes){
        this.title.classes.forEach(titleClass => {
          this.headerClasses.forEach(hdrClass => {
            if(hdrClass.class == titleClass){
              this.selectedHeaderClass = hdrClass;             
            }
          })
          this.alignments.forEach(algnmntClass => {
            if(algnmntClass.class == titleClass){
              this.selectedAlignment = algnmntClass;
            }
          })   
        })
      }else{
        if(this.selectedHeaderClass == undefined){
          this.title?.classes?.push("h6");
          this.selectedHeaderClass = this.headers[0];
        }
        if(this.selectedAlignment == undefined){
          this.title.classes.push("justify-center");
          this.selectedAlignment = this.alignments[1];
        }
        
      }
      this.selectedContent = this.title;
         
    }
    
    
   
    this.textColor = "var(--text-basic-color)";
    
    if(this.section.sectionData.marginBottom != null && this.section.sectionData.marginBottom != undefined){
      this.marginBottom = this.section.sectionData.marginBottom;
    }else{
      this.marginBottom = 32;
    }
    
    
    

    this.bgColors$ = this.cssService.getBgColors().pipe(take(1)).subscribe((colorKV:any[]) => {
      //console.log(colorKV);
      colorKV.forEach((colorObj,i) => {
        if(i < 4){
          this.bgBasic.push(colorObj.val)        
        }else if(i > 3 && i < 8){
          this.bgPrimary.push(colorObj.val)
        }else if(i > 7){
          this.bgAlt.push(colorObj.val)
        }

      })
      //this.fillColors = this.bgBasic.concat(this.bgPrimary).concat(this.bgAlt);
    })
    this.pmColors$ = this.cssService.getPmColors().pipe(take(1))
    .subscribe((colorKV:any[]) => {
      //console.log(colorKV)
      colorKV.forEach((colorObj) => {
        this.primaryColors.push(colorObj.val)
      })
      //console.log(this.primaryColors);
      this.fillColors = this.bgBasic.concat(this.primaryColors).concat(this.bgAlt);
    })
    this.cssService.getCurrentPageBg().subscribe(color => {
      this.currentPageBg = color;
    })

    this.color$ = this.sectionEditorStoreService.color$.pipe(takeUntil(this.destroy$)).subscribe((color:string) => {
      console.log(color);
      if(color != null && color != undefined){
        this.title.color = color;

      }
    })

    this.sectionData$ = this.sectionEditorStoreService.sectionData$.pipe(take(1)).subscribe((sectionData:SectionData) => {
      console.log("Section Data:", sectionData);
      this.sectionData = sectionData
    })

  }

  onChangeContentText(e){
    this.title.text = e;
  }

  onChangeHeaderClass(e){
    console.log("Header Changed")
    this.headerClasses.forEach(headerClass => {
      if(this.title.classes.includes(headerClass.class)){
        let itmIndx = this.title.classes.indexOf(headerClass.class);
        if(itmIndx !== -1){
          this.title.classes.splice(itmIndx,1);
        }
      }
    })
    //Add new class
    this.title.classes.push(e.class)
  }
  onChangeFontFam(e){
    console.log(e)
    this.selectedFontFam = e;
    this.title.fontFamily = e.value;
    this.title.fontFamily = e.value;
  }
  onChangeAlignClass(e){
    console.log(e);
    console.log("Removing class")
    this.alignments.forEach(alignment => {
      if(this.title.classes.includes(alignment.class)){
        let itmIndx = this.title.classes.indexOf(alignment.class);
        if(itmIndx !== -1){
          this.title.classes.splice(itmIndx,1);
        }
      }
    })
    //Add new class
    this.title.classes.push(e.class)
  }
  open(options:any){}

  ngAfterViewInit(): void {
    //let headerHost = <HTMLElement>this.titleHost.nativeElement.firstChild;
    setTimeout(() => {
      

    if(this.title && !this.title.text){
      this.title.text = "No Title"
    }
    if(this.title && this.title.color){
      this.textColor = this.title.color;
      console.log(this.textColor);
    }else{
      //let headerHost = <HTMLElement>this.titleHost.nativeElement.firstChild
      //this.textColor = headerHost.style.getPropertyValue("color");
      console.log(this.textColor);
    }
    if(this.textColor == undefined){
      this.textColor = "#222b45";
    }
    if(this.title && this.title.background) {
      this.background = this.title.background?this.title.background:"none";
    }
    if(this.title && this.title.paddingTop){
      //this.paddingTop = this.title.paddingTop?this.title.paddingTop:headerHost.style.getPropertyValue("margin-bottom");
    }
    }, 1000);
    
  }
  
  // Method to show popover with better positioning
  showPopover(menuBag: NbMenuBag) {
    let popoverComponent:any;
    let popoverContext:any;
    let popoverData:any;
    console.log(menuBag);
    let itemData = menuBag.item?.data;
    if(itemData){
      popoverData = itemData.popoverData != undefined ? itemData.popoverData : menuBag.item?.data;
      //Add context to popoberData if it exists as a separate property of data
      if(itemData.context != undefined){
        popoverData.content = itemData.context;
      }
      console.log(popoverData);
      // Close any existing popover
      if (this.currentOverlayRef) {
        this.currentOverlayRef.dispose();
        this.currentOverlayRef = null;
      }
      popoverComponent = this.getPopoverComponent(popoverData.popoverType);
      popoverContext = this.getPopoverContext(popoverData);
    }
    //const popoverData = menuBag.item?.data?.popoverData != undefined ? menuBag.item.data.popoverData : menuBag.item?.data;
    
    
    
    //
    
    
    if (popoverComponent) {
      // Try to find the clicked menu item element
      const menuElement:HTMLElement = this.menuElementRef?.nativeElement;
      console.log(menuElement)
      let targetElement:ElementRef = this.menuElementRef?.nativeElement;//menuElement;
      
      if (menuElement) {
        // Try to find the specific menu item that was clicked
        const menuItems = menuElement.querySelectorAll('.menu-item');
        
        const clickedIndex = this.sectionDialogMenuItems.findIndex(item => item.title === menuBag.item.title);
        console.log(menuItems,clickedIndex)
        if (clickedIndex >= 0 && menuItems[clickedIndex]) {
          //const clickedIndexEl = menuItems[clickedIndex];
          targetElement = menuItems[clickedIndex] as any;
        }
      }
      console.log("Target Element:", targetElement);
      const positionStrategy = this.positionBuilder
      .connectedTo(targetElement)
      .position(NbPosition.RIGHT)
      .adjustment(NbAdjustment.CLOCKWISE);
    

      // Create the overlay
      this.currentOverlayRef = this.overlayService.create({
        positionStrategy,
        hasBackdrop: true,
        backdropClass: 'cdk-overlay-transparent-backdrop',
      });
      //this.currentOverlayRef = this.overlayService.create(overlayRef);

      // Set the context properties on the component instance
      this.backdropSubscription = this.currentOverlayRef.backdropClick().subscribe(() => {
        //this.currentOverlayRef.dispose();
        this.closePopover();
      });

      const portal = new ComponentPortal(popoverComponent, this.viewContainerRef);
      const componentRef = this.currentOverlayRef.attach(portal);
      //const componentRef = this.viewContainerRef.createComponent(currentComponent);
      //(<SlideDataInteface>componentRef.instance).data = {type:"multi",slide:this.kwRenderSlide.slide};
      console.log(popoverContext);
      Object.assign(componentRef.instance, popoverContext);
      console.log(componentRef)

      // Attach the component to the overlay
      //this.currentOverlayRef.attach(componentRef.hostView);

      // Handle backdrop clicks to close popover
      /* this.currentOverlayRef.backdropClick().subscribe(() => {
        if (this.currentOverlayRef) {
          this.currentOverlayRef.dispose();
          this.currentOverlayRef = null;
        }
      }); */

      // Handle component destruction
      componentRef.onDestroy(() => {
        if (this.currentOverlayRef) {
          this.currentOverlayRef.dispose();
          this.currentOverlayRef = null;
        }
      });
    }
  }
  // Helper method to get the correct popover component
  private getPopoverComponent(popoverType: string): any {
    switch (popoverType) {
      case 'textPopover': return this.textPop;
      case 'fontColor': return this.colorPop;
      case 'fontSize': return this.fontSizePop;
      case 'fontWeight': return this.fontWeight;
      case 'alignLeft': return this.borderPop;
      case 'alignCenter': return this.borderPop;
      case 'alignRight': return this.borderPop;
      case 'margin': return this.borderPop;
      case 'padding': return this.borderPop;
      case 'border': return this.borderPop;
      case 'background': return this.colorPop;
      case 'visibilityPopover':return this.visibilityPop
      default: return null;
    }
  }
  getPopoverContext(popoverData: any) {
    console.log(popoverData);
    return {
      title: popoverData.popoverTitle != undefined ? popoverData.popoverTitle : popoverData.title || "Popover Title",
      headers: this.headers,
      target: popoverData.target,
      property: popoverData.property != undefined ? popoverData.property : undefined,
      service:popoverData.service != undefined ? popoverData.service : undefined,
      color:this.textColor,
      declaration: popoverData.declaration,
      content:popoverData.content != undefined ? popoverData.content : undefined
    };
  }

  private closePopover() {
    console.log("Closing popoover");
    if (this.backdropSubscription) {
      this.backdropSubscription.unsubscribe();
      this.backdropSubscription = null;
    }
    
    if (this.currentOverlayRef) {
      this.currentOverlayRef.dispose();
      this.currentOverlayRef = null;
    }
  }
  
  /* getPopoverComponent(componentName: string) {
    return this[componentName as keyof this];
  } */
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.closePopover();
  }

  onSave(e){
    this.sectionEditorStoreService.sectionData$.pipe(take(1)).subscribe(sectionData => {
      this.previewEditStoreService.selectedSection$.pipe(take(1)).subscribe((section:Section) => {
        console.log("Selected Section:", section, sectionData);
        this.section = {...section,sectionData};
        this.previewEditStoreService.selectedPage$.pipe(take(1)).subscribe((page:Page) => {
          if(page != null && page != undefined){
            console.log("Selected Page:", page);
            //Use the sectionId of the section to find the section in the page and update the selected section with the data from the section
            let sectionIndex = page.sections.findIndex(sec => sec.sectionId == this.section.sectionId);
            //use the index to select the section in the page
            if(sectionIndex !== -1){
              page.sections[sectionIndex] = this.section;
              //Update the page with the new section
              this.previewEditStoreService.updateSelectedSection(this.section);
            }

            this.communicator.sendFromParent({id:"updateSelectedPage",sections:page.sections});    
          }
        })
        /* this.previewEditStoreService.selectedPage$.subscribe(page => {
          console.log("Selected Page:", page);
          this.communicator.sendFromParent({id:"dlCellThumb",data:{elId:this.selectedRenderedSection.elementId,cellId:e.cellId}});
          this.previewEditStoreService.updatePageEditState(EditState.UPDATED);
        }) */
        //this.section = section;
        //console.log(sectionData)
      //this.section.sectionData = sectionData;
      //this.previewEditStoreService.updateSelectedSection(this.section)
      this.ref.close(this.section);        
      })
      
    })
  }
  close(){
    this.ref.close();
  }

  setHorizontalAlign(layoutClass){
    console.log(layoutClass);
    this.sectionEditorStoreService.title$.subscribe((_title:ContentElement) => {
      this.alignments.forEach(alignment => {
        if(_title.classes.includes(alignment.class)){
          let itmIndx = _title.classes.indexOf(alignment.class);
          if(itmIndx !== -1){
            _title.classes.splice(itmIndx,1);
          }
        }
      })
      _title.classes.push(layoutClass);
      this.sectionEditorStoreService.updateTitle(_title)
    })
    /* this.cellEditorStoreService.contentElements$.subscribe((contentElements:ContentElement[]) => {
      let contentElement = contentElements.find(element => element.elId == this.selectedContent.elId);
      contentElement.horizontalAlign = layoutClass;
      //ensure only one alignment class
      this.alignments.forEach(alignment => {
        if(contentElement.classes.includes(alignment.class)){
          let itmIndx = contentElement.classes.indexOf(alignment.class);
          if(itmIndx !== -1){
            contentElement.classes.splice(itmIndx,1);
          }
        }
      })
      contentElement.classes.push(layoutClass);
      this.cellEditorStoreService.updateContentElements(contentElements);
      this.cellEditorStoreService.updateSelectorPosChange(layoutClass);
    }) */
  }

  export(e){
    this.sectionEditorStoreService.sectionData$.subscribe(sectionData =>{
      const fileName = "sectionDefinition"
      const exportType = 'json';
      let jsonData = JSON.stringify(sectionData, null, 2);
      jsonData.replace(/\\n/g, '');
      let data = {"cellDefinition":sectionData};
      console.log(data);
      exportFromJSON({ data, fileName, exportType });
    })  
  }

  snapShot(e){
    let elTarget:string = this.section.rendererType+"-"+this.section.sectionId;
    this.communicator.sendFromParent({id:"snapShot",data:elTarget});
  }
}
